import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio, FormControl } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from '../ContractBlock/Contents/CreditNameLikeness';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class CreditNameLikeness extends Component {
  constructor(props) {
    super(props);
    this.state = { adjust: undefined, changes: { creditTitle: '' } };
  }

  options = () => ({
    creditTitle: this.state.changes.creditTitle,
  });

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept ? !block.accept : block.changes ? true : undefined,
      });
    }
  }

  handleAdjust(adjust) {
    this.setState({ adjust });
    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  handleContent(field, value) {
    const options = this.options();
    options[field] = value;

    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  renderAdjust() {
    const { adjust, changes } = this.state;

    if (adjust === true) {
      return (
        <div className="inner-content">
          <FormGroup>
            <FormControl
              type="text"
              placeholder="enter the credit to be provided here (e.g. Produced By Johnny Jay)"
              value={changes.creditTitle}
              onChange={(e) =>
                this.handleContent('creditTitle', e.target.value)
              }
            />
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    return changeRequest.changes.creditTitle;
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
        isHTML
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">How will the Producer be credited?</p>
              <FormGroup className="answer">
                <Radio
                  name="contribution-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust(false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  {this.props.creditTitle}
                </Radio>
                <hr />
                <Radio
                  name="contribution-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust(true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
                {this.renderAdjust()}
              </FormGroup>
              {this.props.renderAccepts()}
              {this.renderChangeRequests()}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  A credit acknowledges the Producer for their contribution to
                  the master(s) (e.g. “written by, produced by, etc.”).
                  Providing credit can include publicly listing their name,
                  likeness, logos, trademarks, monikers, biographical
                  information, and their role in the creation of the master(s).
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/CreditNameLikeness.jsx